import { render, staticRenderFns } from "./ManageAi.vue?vue&type=template&id=69dc6e7c"
import script from "./ManageAi.vue?vue&type=script&lang=js"
export * from "./ManageAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports